import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { IPartnerPayables } from "../domain/IPartnerPayables";
import { IPaidPayment } from "../domain/IPaidPayment";
import { DailyTableService } from "../services/dt.service";

interface dtPayablesState {
  loading: boolean;
  remainingPayableAmount: number;
  paidPayments: IPaidPayment[];
  error: any;
}

const initialState: dtPayablesState = {
  loading: false,
  remainingPayableAmount: 0,
  paidPayments: [],
  error: undefined,
};

export const getPartnerPayablesWithPayments = createAsyncThunk(
  "DailyTable/getPartnerPayablesWithPayments",
  async () => {
    try {
      const result = await DailyTableService.getPartnerPayablesWithPayments();
      return result;
    } catch (err) {
      setError(err);
    }
  }
);

export const dtPayablesSlice = createSlice({
  name: "Payables",
  initialState: initialState,
  reducers: {
    setPayables: (state, action: PayloadAction<IPartnerPayables>) => {
      state.remainingPayableAmount = action.payload.remainingPayableAmount;
      state.paidPayments = action.payload.payedPayments;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPartnerPayablesWithPayments.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getPartnerPayablesWithPayments.fulfilled,
      (state, action) => {
        state.remainingPayableAmount = action.payload?.remainingPayableAmount
          ? action.payload?.remainingPayableAmount
          : 0;
        state.paidPayments = action.payload?.payedPayments
          ? action.payload.payedPayments
          : [];
        state.loading = false;
      }
    );
    builder.addCase(
      getPartnerPayablesWithPayments.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    );
  },
});

export const selectState = (state: RootState) => state.dailytable.payables;

export const { setError } = dtPayablesSlice.actions;

export default dtPayablesSlice.reducer;
